import { render, staticRenderFns } from "./TagList.vue?vue&type=template&id=6c9b0d8f&scoped=true"
import script from "./TagList.vue?vue&type=script&setup=true&lang=ts"
export * from "./TagList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TagList.vue?vue&type=style&index=0&id=6c9b0d8f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9b0d8f",
  null
  
)

export default component.exports